const featured = [
  {
    id: 1,
    name: "Check Overshirt With Pocket Detail",
    image: "/images/top1.webp",
    oldPrice: "$129.00",
    price: "$112.00",
    popularity: "Trending",
    colors: ["#000", "#f00", "#0f0"],
  },
  {
    id: 2,
    name: "World Wide Cup Print T-Shirt",
    image: "/images/top2.webp",
    oldPrice: "$29.99",
    price: "$23.99",
    colors: ["#000", "#00f", "#fa0"],
  },
  {
    id: 3,
    name: "Slogan Hoodie With Label Detail",
    image: "/images/top3.webp",
    oldPrice: "$18.99",
    price: "$11.99",
    popularity: "Trending",
    colors: ["#ccc", "#ddd", "#333"],
  },
  {
    id: 4,
    name: "Pouch Pocket Hoodie Orange",
    image: "/images/top4.webp",
    oldPrice: "$37.50",
    price: "$29.50",
    popularity: "Trending",
    colors: ["#f60", "#444", "#888"],
  },
  {
    id: 5,
    name: "Check Overshirt With Pocket Detail",
    image: "/images/pr2.webp",
    oldPrice: "$529.00",
    price: "$422.00",
    colors: ["#000", "#f00", "#0f0"],
  },
  {
    id: 6,
    name: "World Wide Cup Print T-Shirt",
    image: "/images/lady10.jpeg",
    oldPrice: "$629.99",
    price: "$523.99",
    colors: ["#000", "#00f", "#fa0"],
  },
  {
    id: 7,
    name: "Slogan Hoodie With Label Detail",
    image: "/images/tshirt.png",
    oldPrice: "$1118.99",
    price: "$1090.99",
    colors: ["#ccc", "#ddd", "#333"],
  },
  {
    id: 8,
    name: "Pouch Pocket Hoodie Orange",
    image: "/images/shoes.webp",
    oldPrice: "$937.50",
    price: "$929.50",
    popularity: "Trending",
    colors: ["#f60", "#444", "#888"],
  },
  {
    id: 9,
    name: "Check Overshirt With Pocket Detail",
    image: "/images/lady5.jpeg",
    oldPrice: "$1229.00",
    price: "$1122.00",
    colors: ["#000", "#f00", "#0f0"],
  },
  {
    id: 10,
    name: "World Wide Cup Print T-Shirt",
    image: "/images/lady7.jpg",
    oldPrice: "$829.99",
    price: "$820.89",
    colors: ["#000", "#00f", "#fa0"],
  },
  {
    id: 11,
    name: "Slogan Hoodie With Label Detail",
    image: "/images/pr1.webp",
    oldPrice: "$1480.99",
    price: "$1290.99",
    popularity: "Less Trending",
    colors: ["#ccc", "#ddd", "#333"],
  },
  {
    id: 12,
    name: "Pouch Pocket Hoodie Orange",
    image: "/images/lady9.jpg",
    oldPrice: "$3237.50",
    price: "$3029.50",
    popularity: "Trending",
    colors: ["#f60", "#444", "#888"],
  },
  {
    id: 9,
    name: "Check Overshirt With Pocket Detail",
    image: "/images/lady5.jpeg",
    oldPrice: "$1229.00",
    price: "$1122.00",
    colors: ["#000", "#f00", "#0f0"],
  },
  {
    id: 10,
    name: "World Wide Cup Print T-Shirt",
    image: "/images/lady7.jpg",
    oldPrice: "$829.99",
    price: "$820.89",
    colors: ["#000", "#00f", "#fa0"],
  },
  {
    id: 11,
    name: "Slogan Hoodie With Label Detail",
    image: "/images/pr1.webp",
    oldPrice: "$1480.99",
    price: "$1290.99",
    popularity: "Less Trending",
    colors: ["#ccc", "#ddd", "#333"],
  },
  {
    id: 12,
    name: "Pouch Pocket Hoodie Orange",
    image: "/images/lady9.jpg",
    oldPrice: "$3237.50",
    price: "$3029.50",
    popularity: "Trending",
    colors: ["#f60", "#444", "#888"],
  },
  {
    id: 9,
    name: "Check Overshirt With Pocket Detail",
    image: "/images/lady5.jpeg",
    oldPrice: "$1229.00",
    price: "$1122.00",
    colors: ["#000", "#f00", "#0f0"],
  },
  {
    id: 10,
    name: "World Wide Cup Print T-Shirt",
    image: "/images/lady7.jpg",
    oldPrice: "$829.99",
    price: "$820.89",
    colors: ["#000", "#00f", "#fa0"],
  },
  {
    id: 11,
    name: "Slogan Hoodie With Label Detail",
    image: "/images/pr1.webp",
    oldPrice: "$1480.99",
    price: "$1290.99",
    popularity: "Less Trending",
    colors: ["#ccc", "#ddd", "#333"],
  },
  {
    id: 12,
    name: "Pouch Pocket Hoodie Orange",
    image: "/images/lady9.jpg",
    oldPrice: "$3237.50",
    price: "$3029.50",
    popularity: "Trending",
    colors: ["#f60", "#444", "#888"],
  },
  // aur bhi products
];
export default featured;